import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteEventService } from '@/services/events'

export const useDeleteEvent = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => deleteEventService(agendaId, eventId),
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['agendas', agendaId, 'events', eventId] })
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'events'] })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
